import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { services } from '../../data/business';
const titles: Record<string, string> = { '/': 'AIで、次のあたりまえを。', '/company': '会社情報', '/service': '事業紹介', '/works': '相談事例・実績', '/news': 'お知らせ', '/recruit': '採用情報', '/contact': 'お問い合わせ', '/interview-arange': 'カジュアル面談', '/privacy-policy': 'プライバシーポリシー', '/security-policy': '情報セキュリティ方針', '/protection-policy': '個人情報保護方針' };
export default function RouteEffects() {
  const { pathname, hash } = useLocation();
  const initial = useRef(true);
  useEffect(() => {
    const service = services.find(item => pathname === `/service/${item.slug}`);
    document.title = `${titles[pathname] || service?.title || 'FRiCTON'} | 株式会社FRiCTON`;
    if (!initial.current) document.getElementById('main-content')?.focus({ preventScroll: true });
    initial.current = false;
    if (!hash) { window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior }); return; }
    let target = hash.slice(1);
    try { target = decodeURIComponent(target); } catch { return; }
    const frame = requestAnimationFrame(() => document.getElementById(target)?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);
  return null;
}
